 (function () {
    const PACKAGE_PROTECTION_VARIANT_ID = 53600877969736;
    const SWITCH_SELECTOR = '#switch2, #switch3';
    const SAFETY_UNLOCK_MS = 15000;

    let previousNormalItemCount = 0;
    let hasInitialized = false;
    let activeOperations = 0;
    let safetyUnlockTimer = null;

    function isProcessing() {
      return activeOperations > 0;
    }

    /* Disable the toggle while a cart action + price update is running,
       so it cannot be switched again until everything is finished. */
    function applyLockState() {
      const locked = isProcessing();
      document.querySelectorAll(SWITCH_SELECTOR).forEach((s) => {
        s.disabled = locked;
        s.classList.toggle('syncing', locked);
        const label = s.closest('.switch');
        if (label) label.classList.toggle('switch--disabled', locked);
      });
    }

    function beginOperation() {
      activeOperations += 1;
      applyLockState();

      if (safetyUnlockTimer) clearTimeout(safetyUnlockTimer);
      safetyUnlockTimer = setTimeout(() => {
        safetyUnlockTimer = null;
        activeOperations = 0;
        applyLockState();
      }, SAFETY_UNLOCK_MS);
    }

    function endOperation() {
      activeOperations = Math.max(0, activeOperations - 1);

      if (activeOperations === 0 && safetyUnlockTimer) {
        clearTimeout(safetyUnlockTimer);
        safetyUnlockTimer = null;
      }

      applyLockState();
    }

    function fetchCart() {
      return fetch('/cart.js').then((response) => response.json());
    }

    function cartHasProtection(cart) {
      return cart.items.some((item) => item.variant_id === PACKAGE_PROTECTION_VARIANT_ID);
    }

    function normalItemQuantity(cart) {
      return cart.items.reduce((sum, item) => {
        return item.variant_id === PACKAGE_PROTECTION_VARIANT_ID ? sum : sum + item.quantity;
      }, 0);
    }

    function updateToggleState(cart) {
      const toggle = document.querySelector('#switch2') || document.querySelector('#switch3');
      if (!toggle) return;
      toggle.checked = cartHasProtection(cart);
    }

    function refreshCartDrawer(cart) {
      const cartDrawer = document.querySelector('cart-drawer');
      const sectionWrapper = cartDrawer?.closest('[id^="shopify-section-"]');
      const sectionId = sectionWrapper?.id;

      if (!cartDrawer || !sectionId) {
        const countSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        const countLabel = document.querySelector('.cart-count-bubble span.visually-hidden');
        if (countSpan) countSpan.textContent = cart.item_count;
        if (countLabel) countLabel.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;
        applyLockState();
        return Promise.resolve();
      }

      return fetch(`${Shopify.routes.root}?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sectionElement = html.getElementById(sectionId);
          const newCartDrawerContent = sectionElement?.querySelector('cart-drawer');

          if (newCartDrawerContent) {
            cartDrawer.replaceChildren(...newCartDrawerContent.children);
          } else if (sectionElement) {
            cartDrawer.innerHTML = sectionElement.innerHTML;
          }

          cartDrawer.classList.toggle('drawer--center-body', cart.item_count === 0);
          const countSpan = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
          const countLabel = document.querySelector('.cart-count-bubble span.visually-hidden');
          if (countSpan) countSpan.textContent = cart.item_count;
          if (countLabel) countLabel.textContent = `${cart.item_count} item${cart.item_count !== 1 ? 's' : ''}`;

          /* Re-rendered section markup comes back enabled, so re-apply the lock. */
          applyLockState();
        });
    }

    function runCartUpdate() {
      return fetchCart()
        .then((cart) => {
          const normalQty = normalItemQuantity(cart);
          const hasProtection = cartHasProtection(cart);

          if (!hasInitialized) {
            hasInitialized = true;
            previousNormalItemCount = normalQty;
            updateToggleState(cart);
            return refreshCartDrawer(cart).then(() => {
              hideCheckoutLoader();
            });
          }

          if (normalQty === 0 && hasProtection) {
            return removePackageProtection()
              .then(fetchCart)
              .then((updatedCart) => {
                updateToggleState(updatedCart);
                previousNormalItemCount = normalItemQuantity(updatedCart);
                return refreshCartDrawer(updatedCart);
              })
              .then(() => {
                hideCheckoutLoader();
              });
          }

          if (normalQty > previousNormalItemCount && !hasProtection) {
            return addPackageProtection()
              .then(fetchCart)
              .then((updatedCart) => {
                updateToggleState(updatedCart);
                previousNormalItemCount = normalItemQuantity(updatedCart);
                return refreshCartDrawer(updatedCart);
              })
              .then(() => {
                hideCheckoutLoader();
              });
          }

          previousNormalItemCount = normalQty;
          updateToggleState(cart);

          return refreshCartDrawer(cart)
            .then(() => {
              hideCheckoutLoader();
            });
        })
        .catch((error) => {
          hideCheckoutLoader();
          console.error('Package protection update failed:', error);
        });
    }

    /* Keeps the toggle locked for the whole refresh cycle:
       cart action -> price recalculation -> drawer re-render. */
    function updateCartAndDrawer() {
      beginOperation();
      return runCartUpdate().then(endOperation, endOperation);
    }

    function syncProtectionState() {
      return fetchCart().then((cart) => {
        updateToggleState(cart);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return cart;
      });
    }

    function showCheckoutLoader() {
      const priceSpan = document.querySelector('.cart-summary__row--total span:last-child');
      if (!priceSpan || priceSpan.dataset.loading) return;

      priceSpan.dataset.loading = "true";
      priceSpan.dataset.original = priceSpan.innerHTML;

      priceSpan.classList.add("loading-price");
      priceSpan.innerHTML = '<span class="price-loader"><span class="price-loader__dot"></span><span class="price-loader__dot"></span><span class="price-loader__dot"></span></span>';
    }

    function hideCheckoutLoader() {
      const priceSpan = document.querySelector('.cart-summary__row--total span:last-child');
      if (!priceSpan || !priceSpan.dataset.loading) return;

      priceSpan.innerHTML = priceSpan.dataset.original;
      priceSpan.classList.remove("loading-price");

      delete priceSpan.dataset.loading;
      delete priceSpan.dataset.original;
    }

    function addPackageProtection() {
      showCheckoutLoader();
      const body = new URLSearchParams();
      body.append('id', PACKAGE_PROTECTION_VARIANT_ID);
      body.append('quantity', '1');

      return fetch('/cart/add.js', {
        method: 'POST',
        body: body
      })
        .then(response => response.json())
        .then(syncProtectionState);
    }

    function removePackageProtection() {
      showCheckoutLoader();
      return fetchCart()
        .then((cart) => {
          const protectionItem = cart.items.find((item) => item.variant_id === PACKAGE_PROTECTION_VARIANT_ID);
          if (!protectionItem) {
            return cart;
          }

          const body = new URLSearchParams();
          body.append('id', protectionItem.key);
          body.append('quantity', '0');

          return fetch('/cart/change.js', {
            method: 'POST',
            body: body
          })
            .then(response => response.json());
        })
        .then(syncProtectionState);
    }

    function handleSwitchChange(evt) {
      evt.preventDefault();

      const switchElement = evt.target;

      /* Fallback guard: a change slipped through while an update is running. */
      if (isProcessing()) {
        switchElement.checked = !switchElement.checked;
        applyLockState();
        return;
      }

      const isTurningOn = switchElement.checked;

      document.querySelectorAll(SWITCH_SELECTOR).forEach(s => {
        s.checked = isTurningOn;
      });

      beginOperation();

      const request = isTurningOn
        ? addPackageProtection()
        : removePackageProtection();

      Promise.resolve(request)
        .then(() => {
          endOperation();
        })
        .catch((error) => {
          console.error('Protection toggle failed, reverting:', error);
          document.querySelectorAll(SWITCH_SELECTOR).forEach(s => {
            s.checked = !isTurningOn;
          });
          endOperation();
        });
    }

    function handleCartButtonClick() {
      setTimeout(updateCartAndDrawer, 100);
    }

    document.addEventListener('change', (evt) => {
      if (evt.target.id === 'switch2' || evt.target.id === 'switch3') {
        handleSwitchChange(evt);
      }
    });

    /* Swallow clicks on the toggle/label while an update is still running. */
    document.addEventListener('click', (evt) => {
      if (!isProcessing()) return;
      const target = evt.target;
      if (target.closest && (target.closest('.package-protection-btn') || target.closest('.switch'))) {
        evt.preventDefault();
        evt.stopPropagation();
      }
    }, true);

    document.addEventListener('click', (evt) => {
      if (evt.target.classList.contains('cart-remove-button') || evt.target.classList.contains('buy-buttons')) {
        handleCartButtonClick();
      }
    }, true);

    document.addEventListener('cart:change', updateCartAndDrawer);
    document.addEventListener('cart:refresh', updateCartAndDrawer);
    document.addEventListener('DOMContentLoaded', updateCartAndDrawer);
  })();